export enum eTypeAsnDocument{
    'Guía' = 1,
    'Factura' = 2,
    'Otro' = 3
}